import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import $ from 'jquery'
import { Close, Save } from '@mui/icons-material'

import { userRightTypes } from '../../../../constants'
import { Button, buttonModes, buttonTypes, AccessControl } from '../../../../components'
import { Logger, LoggerTypes } from '../../../../utils'
import './style.scss'

/**
 * Common footer action bar that allows to save.
 * @param {object} attr Ex: <FlowElementBottomButtons onCancel={onClickCancel} onSave={onClickSave} />
 * @returns {footer}
 */
export const FlowElementBottomButtons = ({ onCancel, onSave }) => {
  const { t } = useTranslation()

  const onClickCancel = (e) => {
    e.stopPropagation()

    $('.commonPage_container_lateral.right').removeClass('open').addClass('close')
    $('.commonPage_container_central.twoSections').removeClass('open').addClass('close')

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementBottomButtons.onClickCancel()', { e })

    if (onCancel && typeof onCancel === 'function') {
      onCancel(e)
    }
  }

  return (
    <footer className="FlowElementBottomButtons">
      <Button
        mode={buttonModes.SECONDARY_ACTION}
        type={buttonTypes.BUTTON}
        text={t('common.cancel')}
        icon={<Close />}
        onClick={onClickCancel}
      />
      <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
        <Button
          mode={buttonModes.PRIMARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.save')}
          icon={<Save />}
          onClick={onSave}
        />
      </AccessControl>
    </footer>
  )
}

FlowElementBottomButtons.displayName = 'FlowElementBottomButtons'

FlowElementBottomButtons.propTypes = {
  onCancel: PropTypes.func,
  onSave: PropTypes.func
}

FlowElementBottomButtons.defaultProps = {
  onCancel: null,
  onSave: null
}
